export type Point = { x: number; y: number };

export const ZOOM_STEP = 0.25;
export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 3;
export const DEFAULT_ZOOM = 1;
export const WHEEL_ZOOM_SENSITIVITY = 0.0015;
// zooming on a trackpad (like those on a MacBook) is different from pinch/zoom,
// so it has its own multiplier.
export const TRACKPAD_PINCH_ZOOM_SENSITIVITY = 0.009;
export const PINCH_ZOOM_EXPONENT = 1;
export const LINE_HEIGHT_PX = 16;
export const PAGE_HEIGHT_PX = 800;
export const ZOOM_EPSILON = 0.0001;
export const DEFAULT_OFFSET: Point = { x: 0, y: 0 };
